import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { Modal, ModalSize } from 'components/notifications';
import { Icon, Intent } from '@blueprintjs/core';
import { Key } from 'components/key';
import { ShowHide } from 'components/layout';
import { GridLayout } from 'components/grid';

export function KeyModal(
    {
        showKeyModal = false,
        closeKeyModal = () => { },
        isInitialising = false,
        screenKey = "MMV",
        ownershipForKeyModal = [],
        assetStatusesForKeyModal = [],
        vehicleActivitiesForKeyModal = [],
        eventStatusesKeyModal = [],
        eventTypesForKeyModal = []
    }
) {
    const [modalSize, setModalSize] = useState(null);

    useEffect(() => {
        if (screenKey) {
            setModalSize(screenKey === "MMF" ? ModalSize.MEDIUM : ModalSize.SMALL)
        }
    }, [screenKey]);


    function renderEventTypes() {
        return eventTypesForKeyModal.map((item) => {
            return (
                <div key={`${item.id}-event-type`} className="inline-items">
                    <i className={`custom-icon custom-icon-${item?.icon}`}/>
                    <label>{item.name}</label>
                </div>
            )
        });
    }

    function renderNote() {
        return (
            <Icon
                icon="document"
                className="keyblock-note-icon"
                style={{
                    color: "#000000",
                    marginLeft: 2,
                    marginRight: 2
                }}
                aria-label="Note"
            />
        )
    }

    return (
        <Modal
            isOpen={showKeyModal}
            clickOutsideClose
            onClose={closeKeyModal}
            title="Key"
            icon="warning-sign"
            intent={Intent.DANGER}
            confirmButtonText="Dismiss"
            onConfirm={closeKeyModal}
            size={modalSize}
            fixedHeight={true}
            fixedHeightPercentage={80}
        >
            <div>
                <div className="spacer-bottom">
                    <div className="col">
                        <h5 className="key">Ownership</h5>
                        <Key rounded listVertical loading={isInitialising} items={ownershipForKeyModal} />
                    </div>
                    <div className="col spacer-left">
                        <h5 className="key">Asset Status</h5>
                        <Key rounded listVertical loading={isInitialising} items={assetStatusesForKeyModal} />
                    </div>
                    <ShowHide
                        evaluator={screenKey === "MMF"}
                        show={(
                            <div className="col spacer-bottom spacer-left">
                                <h5 className="key">Event Status</h5>
                                <Key loading={isInitialising} items={eventStatusesKeyModal} listGrid listGridColumns={2} />
                            </div>
                        )}
                    />
                </div>

                <ShowHide
                    evaluator={screenKey === "MMV"}
                    show={(
                        <div>
                            <div className="col spacer-bottom spacer-left">
                                <h5 className="key">Vehicle Activities</h5>
                                <Key listVertical loading={isInitialising} items={vehicleActivitiesForKeyModal} />
                            </div>
                        </div>
                    )}
                />

                <ShowHide
                    evaluator={screenKey === "MMF"}
                    show={(
                        <div className="col">
                            <h5 className="key">Event Type</h5>
                            <GridLayout numberOfColumns={2}>
                                {renderEventTypes()}
                            </GridLayout>
                        </div>
                    )}
                />

                <ShowHide
                    evaluator={screenKey === "MMF"}
                    show={(
                        <div className="col">
                            <h5 className="key">Note</h5>
                            <GridLayout numberOfColumns={1}>
                                {renderNote()}
                            </GridLayout>
                        </div>
                    )}
                />

            </div>
        </Modal>
    )
}

KeyModal.propTypes = {
    showKeyModal: PropTypes.bool,
    closeKeyModal: PropTypes.func,
    isInitialising: PropTypes.bool,
    screenKey: PropTypes.string,
    ownershipForKeyModal: PropTypes.array.isRequired,
    assetStatusesForKeyModal: PropTypes.array.isRequired,
    vehicleActivitiesForKeyModal: PropTypes.array,
    eventStatusesKeyModal: PropTypes.array,
    eventTypesForKeyModal: PropTypes.array
};